export default "__VITE_ASSET__CEymPIcm__"